import { type PropertiesConfigInputVisualEffectModel } from '@blaze-shared/elements-domain';

import { PropsBuilder } from '../__base/props-builder';

export class SchedulerPropsBuilder extends PropsBuilder<'scheduler'> {
  override setVisualEffect = (
    visualEffect: PropertiesConfigInputVisualEffectModel | undefined,
  ): this => {
    this.patchProps({ style: { background: { visualEffect } } });
    return this;
  };
}
